<!-- <mat-drawer-container class="example-container">
  <mat-drawer-content>
    <app-topnav></app-topnav>
    <app-main-content>
      <router-outlet></router-outlet>
    </app-main-content>
    <app-footer></app-footer>
  </mat-drawer-content>
</mat-drawer-container> -->


<!-- <app-topnav></app-topnav> -->
<!-- <mat-drawer-container>
  <mat-drawer></mat-drawer>
  <mat-drawer-content>
      <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
<app-footer></app-footer> -->


<!--  BEFORE STATUS CHANGES

<div class="example-container">
  <mat-toolbar class="example-toolbar">
    <button mat-icon-button (click)="isExpanded = !isExpanded"><mat-icon>reorder</mat-icon></button>
    <a href="#">
      <img src="./assets/img/favicon.png" style="padding-top: 10px;" alt="MyAnatomy Logo" height="37" />
    </a><p style="padding-left: 8px; font-weight: 380; font-family: Arial, Helvetica, sans-serif; letter-spacing: 1px;">
      MyAnatomy</p>
    <span class="fill-logo-title"></span>
    
    <span class="fill-remaining-space"></span>

  -->

  <div class="example-container">   
      <mat-toolbar class="example-toolbar">
        <button mat-icon-button (click)="isExpanded = !isExpanded" *ngIf="currentRoute"><mat-icon>reorder</mat-icon></button>

        <button mat-icon-button *ngIf="currentRoute" aria-label="Example icon-button with a menu" (click)="onGoBackClick()" matTooltip="Go Back">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <p style="padding-left: 15px; font-weight: 380; font-family: Arial, Helvetica, sans-serif; letter-spacing: 1px; text-align: center; font-size: 23px;">
          MyAnatomy <br/>
          <!-- {{ eventName }} -->
        </p>
        
        <span class="fill-logo-title"></span>
        
        <span class="fill-remaining-space"></span>

        <!-- <a href="#" *ngIf="currentRoute">
          <img src="./assets/img/favicon.png" style="padding-top: 10px;" alt="MyAnatomy Logo" height="37"/>
        </a>
        <img src="./assets/img/favicon.png" style="padding-top: 10px;" alt="MyAnatomy Logo" height="37"*ngIf="!currentRoute"/> -->
        <p style="padding-left: 15px; font-weight: 380; font-family: Arial, Helvetica, sans-serif; letter-spacing: 1px; text-align: center; font-size: 15px;">
          {{ eventName }}
        </p>
  
    <!-- <button mat-icon-button [matMenuTriggerFor]="menu1"  aria-label="Example icon-button with a menu"
      matTooltip="Widgets" matTooltipPosition="left">
      <mat-icon>widgets</mat-icon>
    </button>
    <mat-menu #menu1="matMenu">
      <mat-nav-list>
        <a mat-list-item [routerLink]="['/candidates']" routerLinkActive="active">Candidates</a>
        <a mat-list-item [routerLink]="['/panel-member']" routerLinkActive="active">PanelMembers</a>
        <a mat-list-item [routerLink]="['/processes']" routerLinkActive="active">Process</a>
        <a mat-list-item [routerLink]="['/live-statuses']" routerLinkActive="active">Status</a>
      </mat-nav-list>
    </mat-menu> -->
    <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" matTooltip="Go Back"> -->
    
    <!-- <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <mat-icon>details</mat-icon>
        <span>HR Admin Details</span>
      </button>

      <button mat-menu-item (click)="logout()">
        <mat-icon>power_settings_new</mat-icon>
        <span>Sign Out</span>
      </button>
    </mat-menu> -->
</mat-toolbar>

<mat-sidenav-container class="exampleSidenavContainer" autosize>
  <mat-sidenav #sidenav mode="side" opened="true">
    <mat-nav-list *ngIf="currentRoute">
      <a mat-list-item (click)="toggleActive($event)" [routerLink]="['/dashboard']" routerLinkActive="active" matTooltip="Dashboard" >
        <mat-icon mat-list-icon style="font-weight: bold; color: black;">dashboard</mat-icon>
        <p matLine style="padding-left: 20px;" *ngIf="isExpanded">Dashboard</p>
      </a>
      <mat-divider></mat-divider>
      <a mat-list-item (click)="toggleActive($event)" [routerLink]="['/panel-member']" routerLinkActive="active" matTooltip="Panel Member" >
        <mat-icon mat-list-icon style="font-weight: bold; color: black;">groups</mat-icon>
        <p matLine style="padding-left: 20px;" *ngIf="isExpanded">Panel Member</p>
      </a>
      <a mat-list-item (click)="toggleActive($event)" [routerLink]="['/processes']" routerLinkActive="active" matTooltip="Process">
          <mat-icon mat-list-icon style="font-weight: bold; color: black;">track_changes</mat-icon>
          <p matLine style="padding-left: 20px;" *ngIf="isExpanded">Process</p>
      </a>
      <a mat-list-item (click)="toggleActive($event)" [routerLink]="['/candidates']" routerLinkActive="active" matTooltip="Candidate">
          <mat-icon mat-list-icon style="font-weight: bold; color: black;">person</mat-icon>
          <p matLine style="padding-left: 20px;" *ngIf="isExpanded">Candidate</p>
      </a>
      <a mat-list-item (click)="toggleActive($event)" [routerLink]="['/live-statuses']" routerLinkActive="active" matTooltip="Status">
          <mat-icon mat-list-icon style="font-weight: bold; color: black;">leaderboard</mat-icon>
          <p matLine style="padding-left: 20px;" *ngIf="isExpanded">Status</p>
      </a>

      <!-- <mat-divider></mat-divider>

      <a mat-list-item (click)="toggleActive($event)">
          <mat-icon mat-list-icon>mail</mat-icon>
          <p matLine *ngIf="isExpanded">All Mail</p>
      </a>
      <a mat-list-item (click)="toggleActive($event)">
          <mat-icon mat-list-icon>delete</mat-icon>
          <p matLine *ngIf="isExpanded">Trash</p>
      </a>
      <a mat-list-item (click)="toggleActive($event)">
          <mat-icon mat-list-icon>warning</mat-icon>
          <p matLine *ngIf="isExpanded">Spam</p>
      </a> -->
    </mat-nav-list>
  </mat-sidenav>

  <div>
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-container>
<app-footer></app-footer>
</div>


